import _ from 'underscore'
import Backbone from 'backbone'
import Request from '../helpers/request'
import user from '../user'
import UserModel from '../models/user'
import UserView from './user'

const TeacherView = Backbone.View.extend({
    tagName: 'ul',
    id: 'teacher-view',
    className: 'user-list scrollable',
    render() {
        Request({
            url: '/api/school/teacher',
            method: 'GET',
            data: {
                limit: 500,
                sort: 'firstnameLowercase lastnameLowercase',
            },
        })
            .then((response) => this.listTeachers(response))
        return this
    },
    listTeachers(response) {
        // teacher list
        _.each(response.docs, (userItem) => {
            let userModel = null
            if (userItem._id === user.get('uid')) {
                userModel = user
            } else {
                // set the user details
                userModel = new UserModel({
                    id: userItem._id,
                    email: userItem.email,
                    firstname: userItem.firstname,
                    lastname: userItem.lastname,
                    username: userItem.username,
                    purchased: userItem.appIds,
                })

                // set the type
                if (userItem.type) {
                    userModel.get('type').set('name', userItem.type)
                }

                // set the role
                if (userItem.role) {
                    userModel.get('role').set('name', userItem.role)
                }
            }

            const userView = new UserView({model: userModel})
            this.$el.append(userView.render().el)
        })
    }
})

export default TeacherView